module.exports = __webpack_public_path__ + "img/IMG_1231_L_BlackMatted_MockedUp.034760d1.jpg";